import React from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";

import {
  decodeQueryFromURL,
  onTableChangeUpdateUrl,
  onFilterChangeUpdateUrl,
} from "../../utils/list";

const propTypes = {
  defaultValues: PropTypes.object,
};

const defaultProps = {
  defaultHidden: {},
};

export const WrapperUrlParameters = ({ defaultValues, children }) => {
  const history = useHistory();

  const customDefaultValues = defaultValues || {};

  const onUpdateFilters = (form) => onFilterChangeUpdateUrl(history, form);
  const handleTableChange = (pagination, filters, sorter) =>
    onTableChangeUpdateUrl(history, pagination, filters, sorter);

  const filters = decodeQueryFromURL(history, customDefaultValues);

  return (
    <React.Fragment>
      {children({
        filters,
        onUpdateFilters,
        handleTableChange,
      })}
    </React.Fragment>
  );
};

WrapperUrlParameters.propTypes = propTypes;
WrapperUrlParameters.defaultProps = defaultProps;

export default WrapperUrlParameters;
